import css from '../../../utils/css';

export default css`
  :host,
  #root > div {
    --widget-background-color: #1e1e1e;
    --widget-text-color: #1e1e1e;
    --widget-accent-background-color: #f5f5f5;
    --widget-accent-text-color: black;
    --widget-divider-color: #383838;
    --widget-cta-color: white;
    --widget-cta-background-color: #000000;
    --widget-cta-text-color: black;
    --widget-cta-border-color: #ffffff;

    --widget-cta-primary-color: blue;
    --widget-cta-primary-color-contrast: white;

    --widget-form-selected-background-color: lightgrey;
    --widget-form-selected-border-color: black;
    --widget-child-background-color: white;
    --widget-child-text-color: black;

    --widget-modal-background-color: white;
    --widget-modal-background-color-contrast: black;

    --widget-modal-border-radius-custom: 12px;
    --widget-modal-buttons-border-radius-custom: 24px;

    --widget-cta-color-inverse: white;

    --widget-brand-logo: url('data:image/svg+xml,<svg width="100" height="30" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="30" fill="%23e0e0e0" rx="2"/><text x="50" y="19" font-family="Arial, sans-serif" font-size="10" fill="%23333" text-anchor="middle">placeholder logo</text></svg>');

    --widget-button-border-radius: 32px;
    --widget-button-height: 45;
    --widget-button-background: #f5f5f5;
    --widget-button-background-hover: white;
    --widget-button-selected-background: white;
    --widget-button-selected-text: #ffffff;
    --widget-button-border: 1px solid grey;
  }
`;
